<template>
  <div class="catalog box">
    <div class="part-title">&diams;<span class="inline-title">目录</span></div>
    <div class="tree-item un-tran-b" v-for="(item, index) in treeData" :key="index">
      <div class="tree-root" @click="toggle(index)">
        {{ item.label }} <i class="el-icon-caret-right icon" :class="{ expand: expandKeys.includes(index) }"></i>
      </div>
      <div class="tree-children" :class="{ expand: !expandKeys.includes(index) }">
        <div class="child" v-for="(child, idx) in item.children" :key="`${index}-${idx}`" :title="child.label" @click="goTo(child.page)">
          {{ child.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Custom from '@/api/custom'
let api = new Custom('structureMetaData')
export default {
  data () {
    return {
      treeData: [],
      expandKeys: [0],
      pages: 1
    }
  },
  props: {
    sourceId: String
  },
  methods: {
    toggle (index) {
      if (this.expandKeys.includes(index)) {
        this.expandKeys = this.expandKeys.filter(ele => ele !== index)
      } else {
        this.expandKeys.push(index)
      }
    },
    getData () {
      api
        .getRecords({
          pageIndex: 1,
          pageSize: 999,
          sourceId: this.sourceId
        })
        .then(res => {
          let rows = res.rows
          this.pages = Number(rows[rows.length - 1].endFileName)
          this.treeData = [
            {
              label: rows[0].type,
              children: [
                {
                  label: rows[0].title,
                  page: rows[0].startFileName
                }
              ]
            }
          ]
          for (let i = 1; i < rows.length; i++) {
            if (rows[i].type === rows[i - 1].type) {
              this.treeData[this.treeData.length - 1].children.push({
                label: rows[i].title || rows[i].type,
                page: rows[i].startFileName
              })
            } else {
              this.treeData.push({
                label: rows[i].type,
                children: [
                  {
                    label: rows[i].title || rows[i].type,
                    page: rows[i].startFileName
                  }
                ]
              })
            }
          }
        })
    },
    goTo (page) {
      let url = window.location.origin + window.location.pathname
      let num = Number(page)
      window.open(`${url}#/book${this.$isPhone ? '-mobile' : ''}?sourceId=${this.sourceId}&page=${num || 1}`)
    }
  },
  mounted () {
    this.getData()
  }
}
</script>

<style lang="less" scoped>
@import "~@/styles/variables.less";
@media screen and (min-width: 769px) {
  .catalog {
  position: absolute;
  right: 19px;
  top: 157px;
  width: 320px;
  padding: 38px 16px;
  .c-title {
    color: #4d4030;
    .font-size-medium;
    font-weight: bold;
    margin-bottom: 17px;
  }
  .tree-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    .tree-root {
      width: 274px;
      height: 40px;
      border-radius: 4px;
      border: 2px solid #7c1823;
      padding: 0 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #7a7374;
      .font-size-medium;
      .icon {
        color: #7c1823;
        cursor: pointer;
        transition: transform 0.5s;
        &.expand {
          transform: rotateZ(90deg);
        }
      }
    }
    .tree-children {
      width: 243px;
      height: auto;
      background: #7a7374;
      padding: 3px 6px;
      color: #ffffff;
      overflow-y: hidden;
      &.expand {
        padding: 0;
        height: 0;
      }
      .child {
        width: 100%;
        height: 28px;
        line-height: 28px;
        //  text-align: center;
        color: white;
        .font-size-default;
        cursor: pointer;
        &:hover {
          background-color: #7c1823;
          border-radius: 4px;
        }
      }
    }
  }
}
}
@media screen and (max-width: 768px) {
  .catalog {
  width: 1000px;
  padding: 38px 16px;
  margin-top: 24px;
  .tree-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    .tree-root {
      width: 831px;
      height: 78px;
      border-radius: 4px;
      border: 2px solid #7c1823;
      padding: 0 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #7a7374;
      font-size: 38px;
      font-weight: 600;
      .icon {
        color: #7c1823;
        cursor: pointer;
        transition: transform 0.5s;
        &.expand {
          transform: rotateZ(90deg);
        }
      }
    }
    .tree-children {
      width: 800px;
      height: auto;
      // background: #7a7374;
      padding: 3px 6px;
      // color: #ffffff;
      overflow-y: hidden;
      &.expand {
        padding: 0;
        height: 0;
      }
      .child {
        width: 100%;
        height: 78px;
        line-height: 78px;
        //  text-align: center;
        color: #000000;
        font-size: 38px;
        font-weight: 500;
        cursor: pointer;
        &:hover {
          background-color: #7c1823;
          border-radius: 4px;
          color: white;
        }
      }
    }
  }
}
}
</style>
